import styled from "styled-components";

const Link = styled.a`
    color: #757575;
    font-size: 16px;
    max-width: 100%;
    padding: 0 10px;
    text-align: center;
    word-wrap: break-word;
    text-decoration: none;
    cursor: pointer;
    background-color: transparent;
    margin: 0 25px;

    &:hover {
        color: #757575;
    }
`;
export default Link;
